import { ErrorState } from '../types';

import { DAS_ID_PATTERNS } from './ValidatorDasId';

const FORMAT_ERROR_DIGIT: ErrorState = {
  isError: true,
  message: 'Das ID must be 7 letters followed by 6 digits.',
};

const isValidFormat = (dasId: string) => /^[A-Z]{7}\d{6}$/.test(dasId);

class Validator {
  static validateEmail(email: string): ErrorState {
    if (email === '') {
      return {
        isError: true,
        message: 'Input is empty',
      };
    }

    if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email,
      )
    ) {
      return {
        isError: true,
        message: 'Not a email',
      };
    }

    return {
      isError: false,
      message: '',
    };
  }

  static validatePassword(password: string): ErrorState {
    if (password === '') {
      return {
        isError: true,
        message: 'Password is empty',
      };
    }
    if (password.length < 8) {
      return {
        isError: true,
        message: 'Password length at least 8',
      };
    }

    return {
      isError: false,
      message: '',
    };
  }

  static validateDasLoopDasId(dasId: string): ErrorState {
    if (dasId === '') return { isError: true, message: 'Das ID is empty' };
    if (dasId.length !== 13)
      return { isError: true, message: 'Das ID should be 13 digits' };
    if (!isValidFormat(dasId)) return FORMAT_ERROR_DIGIT;
    const { pattern, name } = DAS_ID_PATTERNS.dasloop!;
    if (!pattern.test(dasId))
      return {
        isError: true,
        message: `Das ID "${dasId}" not match ${name} naming rule`,
      };
    return { isError: false, message: '' };
  }

  static validateDasSenseHDasId(dasId: string): ErrorState {
    if (dasId === '') return { isError: true, message: 'Das ID is empty' };
    if (dasId.length !== 13)
      return { isError: true, message: 'Das ID should be 13 digits' };
    if (!isValidFormat(dasId)) return FORMAT_ERROR_DIGIT;
    const { pattern, name } = DAS_ID_PATTERNS.dassenses!;
    if (!pattern.test(dasId))
      return {
        isError: true,
        message: `Das ID "${dasId}" not match ${name} naming rule`,
      };
    return { isError: false, message: '' };
  }

  static validateDasWBGTDasId(dasId: string): ErrorState {
    if (dasId === '') return { isError: true, message: 'Das ID is empty' };
    if (dasId.length !== 13)
      return { isError: true, message: 'Das ID should be 13 digits' };
    if (!isValidFormat(dasId)) return FORMAT_ERROR_DIGIT;
    const { pattern, name } = DAS_ID_PATTERNS.daswbgt!;
    if (!pattern.test(dasId))
      return {
        isError: true,
        message: `Das ID "${dasId}" not match ${name} naming rule`,
      };
    return { isError: false, message: '' };
  }

  static validateDasTrackDasId(dasId: string): ErrorState {
    if (dasId === '') return { isError: true, message: 'Das ID is empty' };
    if (dasId.length !== 13)
      return { isError: true, message: 'Das ID should be 13 digits' };
    if (!isValidFormat(dasId)) return FORMAT_ERROR_DIGIT;
    const { pattern, name } = DAS_ID_PATTERNS.dastrack!;
    if (!pattern.test(dasId))
      return {
        isError: true,
        message: `Das ID "${dasId}" not match ${name} naming rule`,
      };
    return { isError: false, message: '' };
  }

  static validateDasTrackVDasId(dasId: string): ErrorState {
    if (dasId === '') return { isError: true, message: 'Das ID is empty' };
    if (dasId.length !== 13)
      return { isError: true, message: 'Das ID should be 13 digits' };
    if (!isValidFormat(dasId)) return FORMAT_ERROR_DIGIT;
    const { pattern, name } = DAS_ID_PATTERNS.dastrack_v!;
    if (!pattern.test(dasId))
      return {
        isError: true,
        message: `Das ID "${dasId}" not match ${name} naming rule`,
      };
    return { isError: false, message: '' };
  }

  static validateDasTempDasId(dasId: string): ErrorState {
    if (dasId === '') return { isError: true, message: 'Das ID is empty' };
    if (dasId.length !== 13)
      return { isError: true, message: 'Das ID should be 13 digits' };
    if (!isValidFormat(dasId)) return FORMAT_ERROR_DIGIT;
    const { pattern, name } = DAS_ID_PATTERNS.dastemp!;
    if (!pattern.test(dasId))
      return {
        isError: true,
        message: `Das ID "${dasId}" not match ${name} naming rule`,
      };
    return { isError: false, message: '' };
  }

  static validateDasPowerDasId(dasId: string): ErrorState {
    if (dasId === '') return { isError: true, message: 'Das ID is empty' };
    if (dasId.length !== 13)
      return { isError: true, message: 'Das ID should be 13 digits' };
    if (!isValidFormat(dasId)) return FORMAT_ERROR_DIGIT;
    const { pattern, name } = DAS_ID_PATTERNS.daspower!;
    if (!pattern.test(dasId))
      return {
        isError: true,
        message: `Das ID "${dasId}" not match ${name} naming rule`,
      };
    return { isError: false, message: '' };
  }

  static validateDasAirDasId(dasId: string): ErrorState {
    if (dasId === '') return { isError: true, message: 'Das ID is empty' };
    if (dasId.length !== 13)
      return { isError: true, message: 'Das ID should be 13 digits' };
    if (!isValidFormat(dasId)) return FORMAT_ERROR_DIGIT;
    const { pattern, name } = DAS_ID_PATTERNS.dasair!;
    if (!pattern.test(dasId))
      return {
        isError: true,
        message: `Das ID "${dasId}" not match ${name} naming rule`,
      };
    return { isError: false, message: '' };
  }

  static validateDasAoaTagDasId(dasId: string): ErrorState {
    if (dasId === '') return { isError: true, message: 'Das ID is empty' };
    if (dasId.length !== 13)
      return { isError: true, message: 'Das ID should be 13 digits' };
    if (!isValidFormat(dasId)) return FORMAT_ERROR_DIGIT;
    const { pattern, name } = DAS_ID_PATTERNS.das_aoa_tag!;
    if (!pattern.test(dasId))
      return {
        isError: true,
        message: `Das ID "${dasId}" not match ${name} naming rule`,
      };
    return { isError: false, message: '' };
  }

  static validateDasWaterLDasId(dasId: string): ErrorState {
    if (dasId === '') return { isError: true, message: 'Das ID is empty' };
    if (dasId.length !== 13)
      return { isError: true, message: 'Das ID should be 13 digits' };
    if (!isValidFormat(dasId)) return FORMAT_ERROR_DIGIT;
    const { pattern, name } = DAS_ID_PATTERNS.daswater!;
    if (!pattern.test(dasId))
      return {
        isError: true,
        message: `Das ID "${dasId}" not match ${name} naming rule`,
      };
    return { isError: false, message: '' };
  }

  static validateDasGasDasId(dasId: string): ErrorState {
    if (dasId === '') return { isError: true, message: 'Das ID is empty' };
    if (dasId.length !== 13)
      return { isError: true, message: 'Das ID should be 13 digits' };
    if (!isValidFormat(dasId)) return FORMAT_ERROR_DIGIT;
    const { pattern, name } = DAS_ID_PATTERNS.dasgas!;
    if (!pattern.test(dasId))
      return {
        isError: true,
        message: `Das ID "${dasId}" not match ${name} naming rule`,
      };
    return { isError: false, message: '' };
  }

  static validateDasLockDasId(dasId: string): ErrorState {
    if (dasId === '') return { isError: true, message: 'Das ID is empty' };
    if (dasId.length !== 13)
      return { isError: true, message: 'Das ID should be 13 digits' };
    if (!isValidFormat(dasId)) return FORMAT_ERROR_DIGIT;
    const { pattern, name } = DAS_ID_PATTERNS.daslock!;
    if (!pattern.test(dasId))
      return {
        isError: true,
        message: `Das ID "${dasId}" not match ${name} naming rule`,
      };
    return { isError: false, message: '' };
  }

  static validateDasCasGDasId(dasId: string): ErrorState {
    if (dasId === '') return { isError: true, message: 'Das ID is empty' };
    if (dasId.length !== 13)
      return { isError: true, message: 'Das ID should be 13 digits' };
    if (!isValidFormat(dasId)) return FORMAT_ERROR_DIGIT;
    const { pattern, name } = DAS_ID_PATTERNS.dascas_g!;
    if (!pattern.test(dasId))
      return {
        isError: true,
        message: `Das ID "${dasId}" not match ${name} naming rule`,
      };
    return { isError: false, message: '' };
  }

  static validateDasConcreteDasId(dasId: string): ErrorState {
    if (dasId === '') return { isError: true, message: 'Das ID is empty' };
    if (dasId.length !== 13)
      return { isError: true, message: 'Das ID should be 13 digits' };
    if (!isValidFormat(dasId)) return FORMAT_ERROR_DIGIT;
    const { pattern, name } = DAS_ID_PATTERNS.dasconcrete!;
    if (!pattern.test(dasId))
      return {
        isError: true,
        message: `Das ID "${dasId}" not match ${name} naming rule`,
      };
    return { isError: false, message: '' };
  }

  static validateAIServerDasId(dasId: string): ErrorState {
    if (dasId === '') return { isError: true, message: 'Das ID is empty' };
    if (dasId.length !== 13)
      return { isError: true, message: 'Das ID should be 13 digits' };
    if (!isValidFormat(dasId)) return FORMAT_ERROR_DIGIT;
    const { pattern, name } = DAS_ID_PATTERNS.das_ai_box!;
    if (!pattern.test(dasId))
      return {
        isError: true,
        message: `Das ID "${dasId}" not match ${name} naming rule`,
      };
    return { isError: false, message: '' };
  }

  static validateDasCasDasId(dasId: string): ErrorState {
    if (dasId === '') return { isError: true, message: 'Das ID is empty' };
    if (dasId.length !== 13)
      return { isError: true, message: 'Das ID should be 13 digits' };
    if (!isValidFormat(dasId)) return FORMAT_ERROR_DIGIT;
    const { pattern, name } = DAS_ID_PATTERNS.dascas!;
    if (!pattern.test(dasId))
      return {
        isError: true,
        message: `Das ID "${dasId}" not match ${name} naming rule`,
      };
    return { isError: false, message: '' };
  }

  static validateDasWatchDasId(dasId: string): ErrorState {
    if (dasId === '') return { isError: true, message: 'Das ID is empty' };
    if (dasId.length !== 13)
      return { isError: true, message: 'Das ID should be 13 digits' };
    if (!isValidFormat(dasId)) return FORMAT_ERROR_DIGIT;
    const { pattern, name } = DAS_ID_PATTERNS.daswatch!;
    if (!pattern.test(dasId))
      return {
        isError: true,
        message: `Das ID "${dasId}" not match ${name} naming rule`,
      };
    return { isError: false, message: '' };
  }

  static validateDasRPDasId(dasId: string): ErrorState {
    if (dasId === '') return { isError: true, message: 'Das ID is empty' };
    if (dasId.length !== 13)
      return { isError: true, message: 'Das ID should be 13 digits' };
    if (!isValidFormat(dasId)) return FORMAT_ERROR_DIGIT;
    const { pattern, name } = DAS_ID_PATTERNS.dasrp!;
    if (!pattern.test(dasId))
      return {
        isError: true,
        message: `Das ID "${dasId}" not match ${name} naming rule`,
      };
    return { isError: false, message: '' };
  }

  static validateDasCTagDasId(dasId: string): ErrorState {
    if (dasId === '') return { isError: true, message: 'Das ID is empty' };
    if (dasId.length !== 13)
      return { isError: true, message: 'Das ID should be 13 digits' };
    if (!isValidFormat(dasId)) return FORMAT_ERROR_DIGIT;
    const { pattern, name } = DAS_ID_PATTERNS.das_collision_tag!;
    if (!pattern.test(dasId))
      return {
        isError: true,
        message: `Das ID "${dasId}" not match ${name} naming rule`,
      };
    return { isError: false, message: '' };
  }
}

export default Validator;
